export enum ConnectionStatus {
  AVAILABLE = 'Available',
  ONCALL = 'OnCall',
  NOTAVAILABLE = 'NotAvailable',
}
